/**
 * Entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class TagGroup extends BaseModel {
    defaults() {
        return {
            id: null,
            name: null,
            for_magazin: null,
            for_event: null,
            for_address: null,
            for_schedule: null,
            is_form: null, // Rahmen/Form-Tags
            is_occasion: null, // Ereignisse
            is_additional_info: null, // Zusatzinformationen
            magazin_order: null,
            event_order: null,
            address_order: null,
            slug: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            for_magazin: Boolean,
            for_event: Boolean,
            for_address: Boolean,
            for_schedule: Boolean,
            is_form: Boolean,
            is_occasion: Boolean,
            is_additional_info: Boolean,
            magazin_order: Number,
            event_order: Number,
            address_order: Number,
        };
    }

    entityName() {
        return 'TagGroup';
    }
}

export class TagGroupCollection extends BaseCollection {
    options() {
        return {
            model: TagGroup,
        };
    }

    entityName() {
        return 'TagGroup';
    }
}
